import z from "zod/v4";
import { makeEnum } from "@libs/basic/makeEnum.js";

const values = ["instructor", "manager", "admin"] as const;

export const employeeRoleSchema = z.enum(values);

export const EmployeeRole = makeEnum(values);
export type EmployeeRole = z.infer<typeof employeeRoleSchema>;
